module.exports = __webpack_public_path__ + "static/media/formato_universal_orden_de_trabajo.b7141ddf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/formato_universal_orden_de_trabajo.pdf
// module id = 315
// module chunks = 0